class NumberCounter extends HTMLElement {
  constructor() {
    super();
    this.target = parseInt(this.dataset.target, 10) || 0;
    this.counterEl = this.querySelector(".animate-counter");
    this.duration = 1500;
    this.observer = new IntersectionObserver(
      this.handleIntersection.bind(this),
      { threshold: 0.5 },
    );
    this.observer.observe(this);
  }

  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.observer.disconnect();
        this.animate();
      }
    });
  }

  animate() {
    const start = performance.now();
    const target = this.target;
    const counterEl = this.counterEl;
    const duration = this.duration;

    function step(now) {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      counterEl.textContent = Math.round(eased * target);
      if (progress < 1) {
        requestAnimationFrame(step);
      }
    }

    requestAnimationFrame(step);
  }
}

customElements.define("number-counter", NumberCounter);
